import { Grid } from '@material-ui/core';
import SearchBar from 'components/hocs/searchBar/searchBar';
import { Typography } from 'design_system/src';
import { Sku } from 'models/sku/interfaces/sku.interface';
import { SkuVariant } from 'models/sku-variant/interfaces/sku-variant.interface';
import { useState } from 'react';
import CardSku from './CardSku';

interface SkuSelectorProps {
	skus: Sku[];
	onClick: (sku: Sku, variant: SkuVariant) => void;
	selectedSkuId?: string;
	selectedVariantId?: string;
	loading?: boolean;
}

function SkuSelector({
	skus,
	onClick,
	selectedSkuId,
	selectedVariantId,
	loading,
}: SkuSelectorProps) {
	const [search, setSearch] = useState('');

	const filtered = search.trim()
		? skus.filter((s) => {
				const q = search.toLowerCase();
				return (
					s.code.toLowerCase().includes(q) ||
					s.brandName.toLowerCase().includes(q) ||
					s.modelName.toLowerCase().includes(q) ||
					String(s.year).includes(q)
				);
		  })
		: skus;

	const renderContent = () => {
		if (loading) {
			return (
				<Typography scale="medium" weight="400" textColor="neutral_600">
					Cargando SKUs...
				</Typography>
			);
		}
		if (filtered.length === 0) {
			return (
				<Typography scale="medium" weight="400" textColor="neutral_600">
					No se encontraron SKUs
				</Typography>
			);
		}
		return (
			<div className="overflow_auto flex_1">
				<Grid container spacing={2}>
					{filtered.map((sku) => (
						<Grid item xs={6} key={sku._id}>
							<CardSku
								sku={sku}
								onClick={onClick}
								selected={sku._id === selectedSkuId}
								selectedVariantId={
									sku._id === selectedSkuId ? selectedVariantId : undefined
								}
							/>
						</Grid>
					))}
				</Grid>
			</div>
		);
	};

	return (
		<div className="h_100_per display_flex flex_col p_md">
			<Typography scale="heading3" weight="600" className="m_b_md">
				Seleccionar SKU
			</Typography>
			<div className="m_b_md">
				<SearchBar query={search} setQuery={setSearch} subview />
			</div>
			{renderContent()}
		</div>
	);
}

export default SkuSelector;
